import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function ExecutiveDirectorRoute({component: Component, ...restProps}) {
    const executiveDirector = localStorage.getItem('isExecutiveDirector');

    return <Route
        {...restProps}
        render = {props => {
            return executiveDirector ? <Component {...props} /> : <Redirect to={{pathname: '/login'}} />
        }}
    />
}

export default ExecutiveDirectorRoute;